
export default function FactoryAdvantagesSection() {
  const advantages = [
    {
      title: '稳定订单保障',
      subtitle: '年度合同，稳定收益',
      description: '提供年度采购合同，保障工厂稳定的订单量和现金流，帮助工厂合理规划生产和投资。',
      features: ['年度采购保障', '预付款支持', '订单量承诺', '价格稳定机制'],
      icon: 'ri-contract-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://public.readdy.ai/ai/img_res/ba83dc88e6f1c8d5345fd779c1958d83.jpg'
    },
    {
      title: '技术升级支持',
      subtitle: '设备改造，工艺提升',
      description: '提供先进的茶叶加工技术和设备改造方案，帮助工厂提升生产效率和产品品质。',
      features: ['设备升级资助', '工艺技术指导', '质量管理培训', '生产效率优化'],
      icon: 'ri-tools-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20tea%20processing%20equipment%20upgrade%2C%20modern%20industrial%20machinery%20installation%2C%20technical%20support%20and%20equipment%20modernization%2C%20professional%20technicians%20working%20on%20factory%20equipment%2C%20technology%20improvement%20in%20tea%20manufacturing&width=500&height=300&seq=advantage-02&orientation=landscape'
    },
    {
      title: '品质管控体系',
      subtitle: '标准化生产，品质保证',
      description: '建立完善的品质管控体系，从原料采购到成品出厂全程监控，确保产品品质稳定。',
      features: ['ISO质量体系', '全程质量追溯', '专业检测设备', '品质培训认证'],
      icon: 'ri-shield-check-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Quality%20control%20laboratory%20for%20tea%20products%2C%20professional%20testing%20equipment%2C%20quality%20inspection%20process%2C%20laboratory%20technicians%20analyzing%20tea%20samples%2C%20standardized%20quality%20assurance%20procedures%2C%20modern%20testing%20facility&width=500&height=300&seq=advantage-03&orientation=landscape'
    },
    {
      title: '市场推广共享',
      subtitle: '品牌共建，市场共享',
      description: '共享强大的市场推广资源和销售渠道，帮助工厂产品快速进入市场并建立品牌影响力。',
      features: ['品牌授权使用', '营销资源共享', '渠道对接支持', '市场活动参与'],
      icon: 'ri-megaphone-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Marketing%20and%20brand%20promotion%20for%20tea%20products%2C%20professional%20marketing%20team%20working%20on%20brand%20campaigns%2C%20product%20showcase%20and%20promotional%20materials%2C%20market%20expansion%20strategies%2C%20brand%20building%20activities&width=500&height=300&seq=advantage-04&orientation=landscape'
    }
  ];

  return (
    <section id="advantages" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            合作优势
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            我们为合作工厂提供全方位的支持，共同打造优质茶叶产业链
          </p>
        </div>

        <div className="space-y-16">
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 lg:gap-12`}
            >
              <div className="flex-1">
                <img
                  src={advantage.image}
                  alt={advantage.title}
                  className="w-full h-80 object-cover rounded-2xl shadow-lg"
                />
              </div>
              
              <div className="flex-1 space-y-6">
                <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${advantage.color} flex items-center justify-center mb-4`}>
                  <i className={`${advantage.icon} text-white text-2xl`}></i>
                </div>
                
                <div>
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-2">
                    {advantage.title}
                  </h3>
                  <p className="text-base md:text-lg text-blue-600 font-medium mb-4">
                    {advantage.subtitle}
                  </p>
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-6">
                    {advantage.description}
                  </p>
                </div>
                
                <div className="grid grid-cols-2 gap-3">
                  {advantage.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-gray-700">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                      <span className="text-sm md:text-base">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Benefits */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold mb-4">更多合作福利</h3>
            <p className="text-sm md:text-base text-blue-100">我们为优质工厂提供更多成长机会和发展支持</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-blue-500 rounded-full flex items-center justify-center">
                <i className="ri-award-line text-white text-xl"></i>
              </div>
              <h4 className="text-base md:text-lg font-bold mb-2">优质工厂认证</h4>
              <p className="text-xs md:text-sm text-blue-100">颁发官方认证证书，提升工厂品牌价值</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-blue-500 rounded-full flex items-center justify-center">
                <i className="ri-funds-line text-white text-xl"></i>
              </div>
              <h4 className="text-base md:text-lg font-bold mb-2">资金扶持计划</h4>
              <p className="text-xs md:text-sm text-blue-100">提供低息贷款和设备采购资金支持</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-4 bg-blue-500 rounded-full flex items-center justify-center">
                <i className="ri-global-line text-white text-xl"></i>
              </div>
              <h4 className="text-base md:text-lg font-bold mb-2">国际市场对接</h4>
              <p className="text-xs md:text-sm text-blue-100">协助开拓海外市场，拓展国际业务</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
